/* eslint-disable no-case-declarations */
import _ from 'lodash';
import * as actionTypes from '../actions/details';

const initialState = {
  list: [],
  allList: [],
  loading: false,
  indicatorDetails: [],
  impactDetails: [],
  indicatorLoading: false
};

const detailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DETAILS_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_DETAILS_SUCCESS:
      const { list, isAll } = action.payload;
      const updatedState = {
        ...state,
        loading: false
      };
      if (isAll) {
        updatedState.allList = list;
      } else {
        updatedState.list = list;
      }
      return updatedState;
    case actionTypes.GET_DETAILS_FAILURE:
      return {
        ...state,
        loading: false
      };
    case actionTypes.GET_INDICATORS_DETAILS_START:
      return {
        ...state,
        indicatorLoading: true,
        indicatorDetails: []
      };
    case actionTypes.GET_INDICATORS_DETAILS_SUCCESS:
      const { results, indicatorId } = action.payload;
      const grouped = _.chain(results.data)
        .groupBy('Accounts.name')
        .map((value, key) => ({ npo: key, rows: value }))
        .value();
      const indicatorDetails = [];
      grouped.forEach(({ npo, rows }) => {
        const detail = {
          npo,
          total_claim: 0,
          sroi: 0,
          leverage: 0,
          allocation: 0,
          reports: []
        };
        rows.forEach(report => {
          detail.reports.push({
            report: report['Reports.name'],
            total_claim: report['Claims.totalLeveragedClaim'],
            sroi: report['Claims.sroiRow'],
            leverage: report['Claims.leveragePercentage'],
            allocation: report['Claims.costCurrentDirectCash'],
            indicator: report['Indicators.name']
          });
          detail.total_claim += report['Claims.totalLeveragedClaim'];
          detail.sroi += report['Claims.sroiRow'];
          detail.leverage += report['Claims.leveragePercentage'];
          detail.allocation += report['Claims.costCurrentDirectCash'];
        });
        detail.leverage /= detail.reports.length;
        indicatorDetails.push(detail);
      });
      const newState = {
        ...state,
        indicatorLoading: false
      };
      if (indicatorId) {
        newState.indicatorDetails = indicatorDetails;
      } else {
        newState.impactDetails = indicatorDetails;
      }
      return newState;
    case actionTypes.GET_INDICATORS_DETAILS_FAILURE:
      return {
        ...state,
        indicatorLoading: false
      };
    default: {
      return state;
    }
  }
};

export default detailsReducer;
